import type { SVGProps } from 'react';

import * as styles from './LegacyFindBrokersIcon.css';

export const LegacyFindBrokersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={styles.briefcaseIcon}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    // xml:space="preserve"
  >
    <path
      d="M14,3.3c0.1,0,0.2,0,0.3,0.1s0.1,0.2,0.1,0.3v8.9c0,0.1,0,0.2-0.1,0.3s-0.2,0.1-0.3,0.1H0.9
			c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.1-0.3V3.7c0-0.1,0-0.2,0.1-0.3s0.2-0.1,0.3-0.1h3.8V1.9c0-0.1,0-0.2,0.1-0.3S5,1.4,5.2,1.4h4.6
			c0.1,0,0.2,0,0.3,0.1s0.1,0.2,0.1,0.3v1.4H14z M1.4,4.2v2.3H7V6.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
			c0.1,0,0.2,0,0.3,0.1S8,6,8,6.1v0.5h5.6V4.2H1.4z M1.4,12.2h12.2V7.5H8V8c0,0.1,0,0.2-0.1,0.3S7.7,8.4,7.5,8.4
			c-0.1,0-0.2,0-0.3-0.1C7.1,8.2,7,8.1,7,8V7.5H1.4V12.2z M5.7,2.4v0.9h3.7V2.4H5.7z"
    />
  </svg>
);
